<template>
  <div class="table">
    <div class="tableData">
        <div class="tr" v-for="(item,index) in formDataList" :key="index">
          <div class="td">
              <p class="label" :style="`width: ${labelWidth}px;`">{{item.label}}</p>
              <p class="value">{{formData[item.value]}}</p>
          </div>
          <div class="tr" v-if="item.children && item.children.length > 0">
            <div class="td" v-for="(e,i) in item.children" :key="i">
                <p class="label" :style="`width: ${labelWidth}px;`">{{e.label}}</p>
                <p class="value">{{formData[e.value]}}</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: {
    // 宽度
    labelWidth: {
      type: String,
      default: "150"
    },
    // 显示字段数据
    formDataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 显示数据
    formData: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.table {
  .tableData {
    border: 1px solid #E9E9E9;
    border-bottom: 0;
    border-right: 0;
    .tr {
      display: flex;
      align-items: stretch;
      box-sizing: border-box;
      .td,.tr {
        flex: 1;
        display: flex;
        box-sizing: border-box;
        .label {
          padding: 15px 10px;
          background: #FAFAFA;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
          width: 150px;
          border-bottom: 1px solid #E9E9E9;
          line-height: 22px;
          display: flex;
          // text-align: left;
          justify-content: left;
          @media (min-width: 2160px) {
            font-size: 18px !important;
          }
        }
        .value{
          padding: 13px 20px;
          font-size: 16px;
          color: rgba(0,0,0,0.85);
          line-height: 22px;
          flex: 1;
          border: 1px solid #E9E9E9;
          border-top: 0;
          display: flex;
          word-break: break-all;
          @media (min-width: 2160px) {
            font-size: 18px !important;
          }
        }
      }
      >.tr{
        flex: 1.5;
      }
    }
  }
}
</style>